module.exports = __webpack_public_path__ + "media/components/assets/img/logo/swiss-c4abeff15fcb45a83020ce95fd723e04.png";